class DreambabyCalculateBasket {
  constructor() {
    this.cartUpdateUnsubscriber = null;
    const scriptTag = document.querySelector('script[data-api-endpoint]');
    this.apiEndpoint = scriptTag?.dataset?.apiEndpoint;
    this.customerId = scriptTag?.dataset?.customerId || '';
    this.proxyToken = scriptTag?.dataset?.proxyToken;
    this.errorFetchApiFailed = scriptTag?.dataset?.errorFetchApiFailed || 'Could not update your cart with the latest promotions. Please try again or contact support if the issue persists.';
    this.errorUpdateCartAttributeFailed = scriptTag?.dataset?.errorUpdateCartAttributeFailed || 'There was an issue saving promotion details to your cart. Please try again.';
    this.successUpdatedCartAttribute = scriptTag?.dataset?.successUpdatedCartAttribute || 'Your cart has been updated with the latest promotions.';

    if (!this.apiEndpoint) {
      console.error('[DreambabyCalculateBasket] API endpoint not set in data attributes');
      return;
    }

    this.init();
  }

  init() {
    if ('undefined' === typeof subscribe || 'undefined' === typeof PUB_SUB_EVENTS) {
      console.error('[DreambabyCalculateBasket] Required dependencies not loaded');
      return;
    }
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if ('dreambaby-calculate-basket' === event.source) {
        return;
      }

      if ('cart-items' === event.source && event.cartData) {
        if (0 === event.cartData.item_count && '{}' !== event.cartData.attributes?.calculateBasketResponse) {
          this.updateCalculateBasketResponseAttribute('{}');
          return;
        }
      }
      this.fetchCartAndSendToApi();
    });
  }

  async fetchCartAndSendToApi() {
    try {
      const cartResponse = await fetch('/cart.js');
      if (true !== cartResponse.ok) {
        throw new Error('Failed to fetch cart data');
      }

      const cartData = await cartResponse.json();

      if (0 === cartData.items.length && '{}' !== cartData.attributes?.calculateBasketResponse) {
        this.updateCalculateBasketResponseAttribute('{}');
        return;
      }
      const apiResponse = await fetch(this.apiEndpoint + '?authorization=fixed', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.proxyToken}`
        },
        body: JSON.stringify({
          customerId: this.customerId || null,
          items: cartData.items.map(item => ({
            variantId: item.variant_id.toString(),
            sku: item.sku,
            quantity: item.quantity
          })),
          applyLoyaltyWallet: false,
          applyGiftlistWallet: false,
          shippingCost: 0
        })
      });

      if (true !== apiResponse.ok) {
        throw new Error(`API request failed with status ${apiResponse.status}`);
      }

      const responseData = await apiResponse.json();

      if (!this.objectsAreDifferent(cartData.attributes?.calculateBasketResponse, responseData)) {
        console.log('[DreambabyCalculateBasket] Response unchanged, not updating cart attributes');
        return;
      }

      const isProductPage = document.body.classList.contains('page-product') || window.location.pathname.includes('/products/');

      // dont show the success notification, we already show an update of the basket at the same place right bottom of screen this comes in front of that
      this.updateCalculateBasketResponseAttribute(responseData, false);
      this.logCartErrors(responseData);
    } catch (error) {
      console.error('[DreambabyCalculateBasket] Error in fetchCartAndSendToApi:', error);
      if (typeof window.DreambabyNotificationHandler.showNotification === 'function') {
        window.DreambabyNotificationHandler.showNotification(this.errorFetchApiFailed, 'warning');
      }
    }
  }

  async updateCalculateBasketResponseAttribute(responseData, showSuccessNotification = true) {
    try {
      const cartUpdateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            calculateBasketResponse: JSON.stringify(responseData)
          }
        })
      });

      if (true !== cartUpdateResponse.ok) {
        throw new Error('Failed to update calculateBasketResponse cart attribute');
      }
      if ('undefined' !== typeof publish && 'undefined' !== typeof PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'dreambaby-calculate-basket',
          apiResponse: responseData
        });
      }
      if (showSuccessNotification && typeof window.DreambabyNotificationHandler.showNotification === 'function') {
        window.DreambabyNotificationHandler.showNotification(this.successUpdatedCartAttribute, 'success');
      }
      console.log('[DreambabyCalculateBasket] calculateBasketResponse cart attribute updated');
    } catch (error) {
      console.error('[DreambabyCalculateBasket] Error in updateCalculateBasketResponseAttribute:', error);
      if (typeof window.DreambabyNotificationHandler.showNotification === 'function') {
        window.DreambabyNotificationHandler.showNotification(this.errorUpdateCartAttributeFailed, 'error');
      }
    }
  }

  objectsAreDifferent(firstObject, secondObject) {
    if (!firstObject) {
      return true;
    }

    try {
      return JSON.stringify(JSON.parse(firstObject)) !== JSON.stringify(secondObject);
    } catch (error) {
      console.error('[DreambabyCalculateBasket] Error in objectsAreDifferent:', error);
      return true;
    }
  }

  destroy() {
    if (null !== this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
      this.cartUpdateUnsubscriber = null;
    }
  }

  logCartErrors(responseData) {
    const errors = responseData?.result?.errors || [];
    if (0 < errors.length) {
      console.warn('[DreambabyCalculateBasket] Errors in calculate basket response:', errors);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.dreambabyCalculateBasket = new DreambabyCalculateBasket();
});
